import type { SipPlansCategory, SipDecreaseRecommendation } from '../../../../api/sipPlan.types'
import { SipCategoryBucketKey, SIP_CATEGORY_BUCKET_TITLES, SipPlanMode, type SipActionFilter } from '../../../../api/types'
import { useSipPlanCategoryBucket } from '../../../usePlanCategoryBucketExpansion'
import { BucketAccordion } from '../../../../../lumpsum/plans-list/lumpsum-ui-components/BucketAccordion'
import { DecreaseSipFundCard } from '../cards/DecreaseSipFundCard'
import { getCategoryBucketItems } from '../../../../../utils/categoryBucketsUtils'
import { EventNames } from '../../../../../../../../types/misc.types'
import { trackEvent } from '../../../../../../../../utils/appBridge'
import { PlansScreen, PlansSipListEventIds } from '../../../../../analytics/plansEvents'

type DecreaseSipBucketAccordionProps = {
  category: SipPlansCategory
  categoryId: string
  actionFilter: SipActionFilter
  isBorderTop?: boolean
}

export function DecreaseSipBucketAccordion({
  category,
  categoryId,
  actionFilter,
  isBorderTop = false
}: DecreaseSipBucketAccordionProps) {
  const decreaseRecommendations = getCategoryBucketItems<SipDecreaseRecommendation>(category?.decreaseRecommendations)
  const { bucketCompositeKey, isExpanded, toggle } = useSipPlanCategoryBucket({
    planMode: SipPlanMode.YOUR_PLAN,
    actionFilter,
    categoryId,
    bucketKey: SipCategoryBucketKey.decreaseRecommendations
  })

  return (
    <BucketAccordion
      bucketCompositeKey={bucketCompositeKey}
      title={SIP_CATEGORY_BUCKET_TITLES[SipCategoryBucketKey.decreaseRecommendations]}
      count={decreaseRecommendations.length}
      isExpanded={isExpanded}
      onToggle={() => {
        trackEvent({
          eventName: EventNames.UserClicked,
          payload: {
            ScreenName: PlansScreen.SipYourPlan,
            eventId: PlansSipListEventIds.BucketAccordion,
            buttonLabel: SIP_CATEGORY_BUCKET_TITLES[SipCategoryBucketKey.decreaseRecommendations]
          }
        })
        toggle()
      }}
      isBorderTop={isBorderTop}
    >
      {decreaseRecommendations.map((recommendation, recommendationIndex) => (
        <DecreaseSipFundCard
          key={`${recommendation?.isin ?? 'fund'}-${recommendationIndex}`}
          recommendation={recommendation}
          showBottomDivider={recommendationIndex < decreaseRecommendations.length - 1}
        />
      ))}
    </BucketAccordion>
  )
}
